module.exports = "/_next/static/images/a7a509ef2dda4f260a3bd4720a77014d-bubble-gum-woman-square@xs-2x.jpg";